import { Moon, Sun } from 'lucide-react';
import { useTheme } from '@/contexts/ThemeContext';
import { useTranslation } from 'react-i18next';

/**
 * DarkModeToggle Component
 * Circular button that toggles between light and dark modes
 * Both modes use WCAG 2.2 AA compliant colors
 */
export function DarkModeToggle() {
  const { isDarkMode, toggleDarkMode } = useTheme();
  const { t } = useTranslation();

  return (
    <button
      type="button"
      onClick={toggleDarkMode}
      className="relative flex items-center justify-center rounded-full transition-all duration-200 hover:scale-105"
      style={{
        width: '56px',
        height: '56px',
        backgroundColor: 'var(--theme-surface)',
        color: 'var(--theme-text)',
        border: '3px solid var(--theme-border)',
        boxShadow: '2px 2px 0px var(--theme-border)',
      }}
      aria-label={isDarkMode ? t('common:a11y.switchToLightMode') : t('common:a11y.switchToDarkMode')}
      title={isDarkMode ? t('common:a11y.lightMode') : t('common:a11y.darkMode')}
    >
      {isDarkMode ? (
        <Sun className="h-7 w-7" aria-hidden="true" />
      ) : (
        <Moon className="h-7 w-7" aria-hidden="true" />
      )}
    </button>
  );
}
